import React, { useState, useEffect } from 'react';

const PasswordProtection = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Password from environment variable
  const SITE_PASSWORD = process.env.REACT_APP_SITE_PASSWORD;

  // Check if already authenticated (stored in sessionStorage)
  useEffect(() => {
    // If no password is configured, skip protection entirely
    if (!SITE_PASSWORD) {
      setIsAuthenticated(true);
      return;
    }

    const auth = sessionStorage.getItem('site_authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, [SITE_PASSWORD]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === SITE_PASSWORD) {
      sessionStorage.setItem('site_authenticated', 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  // If no password configured, render children without protection
  if (!SITE_PASSWORD) {
    return children;
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Simply Flora</h1>
          <p className="text-gray-600">This site is password protected</p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
              Enter Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent"
              placeholder="Enter password"
              autoFocus
            />
          </div>
          
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
              {error}
            </div>
          )}
          
          <button
            type="submit"
            className="w-full bg-pink-600 hover:bg-pink-700 text-white font-semibold py-3 px-4 rounded-lg transition duration-200"
          >
            Access Site
          </button>
        </form>
        
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>Contact support if you need access</p>
        </div>
      </div>
    </div>
  );
};

export default PasswordProtection;
